import React, { useState, useEffect } from 'react';
import './Common.css';
import { useAuth } from '../../AuthContext';
import { useNavigate } from 'react-router-dom';
import Navbar from '../Navbar';
import Footer from "../../Footer";
import { ChevronLeft, ChevronRight } from 'lucide-react'; // Import icons for slider buttons
import slider1 from '../../../assets/slider1.png';
import slider2 from '../../../assets/slider2.png';
import slider3 from '../../../assets/slider3.png';
import slider4 from '../../../assets/slider4.png';

const Students = () => {
    const [activeTab, setActiveTab] = useState('8thTo12th');
    const { user } = useAuth();
    const navigate = useNavigate();

    // Slider state and logic
    const [currentSlide, setCurrentSlide] = useState(0);

    const images = [
        {
            src: slider1,
            title: 'Confusion to Clarity',
            description: 'Uniaariv empowers you to discover yourself, align your uniqueness, strengths, etc. with your natural inclination, unlock your fullest potential, and step into a future that’s truly yours (the field/sector) to do, be, succeed, and live an accomplished life.',
        },

    ];


    const handleTakeAssessment = () => {
        if (user) {
            navigate('/quiz-selection');
        } else {
            navigate('/login');
        }
    };

    return (
        <div className="page">
            <Navbar />
            <div className="hero-section">
                {/* Replace the static image with the slider */}
                <div className="hero-slider">

                    <div className="slider-container">
                        {images.map((image, index) => (
                            <div key={index} className={`slide ${index === currentSlide ? 'active' : ''}`}>
                                <img src={image.src} alt={`Slide ${index + 1}`} className="slide-image" />
                                <div className="slide-content">
                                    <p>{image.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
                <h1>Students / Job Seekers / Self Awareness</h1>
            </div>

            <div className="tabs">
                <button
                    className={activeTab === '8thTo12th' ? 'active' : ''}
                    onClick={() => setActiveTab('8thTo12th')}
                >
                    8th to 12th Standard
                </button>
                <button
                    className={activeTab === 'competitive' ? 'active' : ''}
                    onClick={() => setActiveTab('competitive')}
                >
                    Competitive/Professional Exam Aspirant
                </button>
                <button
                    className={activeTab === 'entrepreneurial' ? 'active' : ''}
                    onClick={() => setActiveTab('entrepreneurial')}
                >
                    Entrepreneurial Aspirant
                </button>
            </div>

            <div className="tab-content">
                {activeTab === '8thTo12th' && (
                    <div>
                        <h2>Confusion to Clarity</h2>
                        <p>
                            Are you struggling to identify the right career path or unsure about which field is most aligned with your strengths, uniqueness, and natural inclination? The journey from confusion to clarity can be overwhelming, especially when you are in a state of confusion and don't have the right guidance.
                        </p>
                        <p>
                            UNIAARIV's proprietary TrueIN Model © helps students like you discover who you truly are, providing insight into your unique personality, strengths, and areas for growth. It helps you:
                        </p>
                        <ul className="principles-list">
                            <li><b>Uncover Your Natural Strengths:</b> Recognize your innate abilities and how they can align with different career opportunities. You'll understand not only your strengths but also areas that could become challenges if left unaddressed.</li>
                            <li><b>Make Informed Career Choices:</b> Break free from the external influences of society, family, or peer pressure. Our report will help you choose a path that aligns with your natural inclinations and strengths, increasing the likelihood of both success and happiness.</li>
                            <li><b>Gain Self-Awareness:</b> Discover how to navigate potential obstacles in your path, mitigate risks of failure, and embrace your fullest potential.</li>
                        </ul>
                        <p>
                            Instead of making career decisions based on guesswork or external influence or pressure, our TrueIN © assessment enables you to make empowered, conscious, and data-driven decisions. The result? A future where you not only succeed but thrive, enjoying your journey every step of the way and experiencing happiness.
                        </p>
                    </div>
                )}
                {activeTab === 'competitive' && (
                    <div>
                        <h2>Confusion to Clarity</h2>
                        <p>
                            Are you struggling to identify the right career path or unsure about which field is most aligned with your strengths, uniqueness, and natural inclination? The journey from confusion to clarity can be overwhelming, especially when you are in a state of confusion and don't have the right guidance.
                        </p>
                        <p>
                            UNIAARIV's proprietary TrueIN Model © helps students like you discover who you truly are, providing insight into your unique personality, strengths, and areas for growth. It helps you:
                        </p>
                        <ul className="principles-list">
                            <li><b>Uncover Your Natural Strengths:</b> Recognize your innate abilities and how they can align with different career opportunities. You'll understand not only your strengths but also areas that could become challenges if left unaddressed.</li>
                            <li><b>Make Informed Career Choices:</b> Break free from the external influences of society, family, or peer pressure. Our report will help you choose a path that aligns with your natural inclinations and strengths, increasing the likelihood of both success and happiness.</li>
                            <li><b>Gain Self-Awareness:</b> Discover how to navigate potential obstacles in your path, mitigate risks of failure, and embrace your fullest potential.</li>
                        </ul>
                        <p>
                            Instead of making career decisions based on guesswork or external influence or pressure, our TrueIN © assessment enables you to make empowered, conscious, and data-driven decisions. The result? A future where you not only succeed but thrive, enjoying your journey every step of the way and experiencing happiness.
                        </p>
                    </div>
                )}
                {activeTab === 'entrepreneurial' && (
                    <div>
                        <h2>Confusion to Clarity</h2>
                        <p>
                            Are you struggling to identify the right career path or unsure about which field is most aligned with your strengths, uniqueness, and natural inclination? The journey from confusion to clarity can be overwhelming, especially when you are in a state of confusion and don't have the right guidance.
                        </p>
                        <p>
                            UNIAARIV's proprietary TrueIN Model © helps students like you discover who you truly are, providing insight into your unique personality, strengths, and areas for growth. It helps you:
                        </p>
                        <ul className="principles-list">
                            <li><b>Uncover Your Natural Strengths:</b> Recognize your innate abilities and how they can align with different career opportunities. You'll understand not only your strengths but also areas that could become challenges if left unaddressed.</li>
                            <li><b>Make Informed Career Choices:</b> Break free from the external influences of society, family, or peer pressure. Our report will help you choose a path that aligns with your natural inclinations and strengths, increasing the likelihood of both success and happiness.</li>
                            <li><b>Gain Self-Awareness:</b> Discover how to navigate potential obstacles in your path, mitigate risks of failure, and embrace your fullest potential.</li>
                        </ul>
                        <p>
                            Instead of making career decisions based on guesswork or external influence or pressure, our TrueIN © assessment enables you to make empowered, conscious, and data-driven decisions. The result? A future where you not only succeed but thrive, enjoying your journey every step of the way and experiencing happiness.
                        </p>
                    </div>
                )}
            </div>

            <div className="empowers-section">
                <h2>How UNIAARIV Empowers Students</h2>
                <ul className="empowers-list">
                    <li>
                        Mirror-like reflection helps to know one’s uniqueness, inherent strengths, including weaknesses that may turn into a roadblock.
                    </li>
                    <li>
                        Mitigate the risk of choosing a field wherein the likelihood of success is low and help save precious time and resources.
                    </li>
                    <li>
                        Possible career options, be it a job, entrepreneurship, or public administrative services, which best suit one’s natural inclination.
                    </li>
                    <li>
                        Make conscious career choices free from external influence, say parents, friends, society, or market trends.
                    </li>
                    <li>
                        Pursue a field/sector wherein a student is naturally inclined and most likely to outperform, succeed, and even enjoy.
                    </li>
                    <li>
                        Help to know self-defined psychological boundaries, possible ways out, and explore one’s own fullest potential.
                    </li>
                </ul>
            </div>

            <div className="take-assessment-container">
                <button className="take-assessment-btn" onClick={handleTakeAssessment}>
                    Take Assessment
                    <svg className="icon" viewBox="0 0 24 24" fill="currentColor">
                        <path
                            fillRule="evenodd"
                            d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
                            clipRule="evenodd"
                        ></path>
                    </svg>
                </button>
            </div>
            <Footer />
        </div>
    );
};

export default Students;